var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.data
      ? _c(
          "a",
          {
            staticClass: "estate-card",
            attrs: { href: _vm.route(_vm.computedUrl, _vm.computedUrlParams) },
          },
          [
            _c("img", {
              staticClass: "dynamic-image",
              attrs: {
                "data-object-fit": "cover",
                src: _vm.data.pictures[0].urlLarge,
                alt: _vm.data.name,
              },
            }),
            _vm._v(" "),
            [3, 4, 5].includes(_vm.data.purposeStatus.id)
              ? _c("div", { staticClass: "ribbon" }, [
                  _vm.data.purposeStatus.id === 3
                    ? _c("p", { staticClass: "text-cyan m-0" }, [
                        _vm._v("\n        Dichtblij"),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-white fw-b" }, [
                          _vm._v("Verkocht"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.purposeStatus.id === 4
                    ? _c("p", { staticClass: "text-cyan m-0" }, [
                        _vm._v("\n        Dichtblij"),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-white fw-b" }, [
                          _vm._v("Verhuurd"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.purposeStatus.id === 5 ||
                  _vm.data.purposeStatus.id === 6
                    ? _c("p", { staticClass: "text-cyan m-0" }, [
                        _vm._v("in "),
                        _c("span", { staticClass: "text-white fw-b" }, [
                          _vm._v("Optie"),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "content d-flex flex-column justify-content-between",
              },
              [
                _c("h4", [_vm._v(_vm._s(_vm.data.name))]),
                _vm._v(" "),
                _vm.data.purpose
                  ? _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.formatPriceLabel(
                            _vm.data.price,
                            _vm.data.currency,
                            _vm.data.purposeStatus.id,
                            this.data.purpose.id
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm.data.city
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-inline-flex flex-row justify-content-center",
                        },
                        [
                          _c("svg-vue", {
                            attrs: { icon: "locatie-vastgoed-c-orange" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "svg-text" }, [
                            _vm._v(_vm._s(_vm.data.city)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.rooms
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-inline-flex flex-row justify-content-center",
                        },
                        [
                          _c("svg-vue", {
                            attrs: { icon: "bed-vastgoed-c-orange" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "svg-text" }, [
                            _vm._v(_vm._s(_vm.data.rooms)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }